/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Subtitle_Import_Multi_Files_NoteInputs */



/**
* | output |
* | --- |
* | "{count} files selected. Each file will be imported into its own new Event Group." |
*
* @param {Subtitle_Import_Multi_Files_NoteInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_import_multi_files_note = /** @type {((inputs: Subtitle_Import_Multi_Files_NoteInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Import_Multi_Files_NoteInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.count} fichiers sélectionnés. Chaque fichier sera importé dans son propre nouveau groupe d'événements.`)
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} Dateien ausgewählt. Jede Datei wird in eine eigene neue Ereignisgruppe importiert.`)
	if (locale === "it") return /** @type {LocalizedString} */ (`${i?.count} file selezionati. Ogni file verrà importato in un nuovo gruppo di eventi.`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Выбрано файлов: ${i?.count}. Каждый файл будет импортирован в отдельную новую группу событий.`)
	if (locale === "es") return /** @type {LocalizedString} */ (`${i?.count} archivos seleccionados. Cada archivo se importará en su propio grupo de eventos nuevo.`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`已选择 ${i?.count} 个文件。每个文件将导入到各自的新事件组中。`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.count} 個のファイルが選択されています。各ファイルはそれぞれ新しいイベントグループにインポートされます。`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.count} फ़ाइलें चुनी गईं। हर फ़ाइल अपने नए इवेंट समूह में आयात की जाएगी।`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`${i?.count} ficheiros selecionados. Cada ficheiro será importado para o seu próprio novo grupo de eventos.`)
	return /** @type {LocalizedString} */ (`${i?.count} files selected. Each file will be imported into its own new Event Group.`)
});